import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "winner", -1)
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "white-border" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", { class: "text-no-wrap" }, "votes", -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "white-border" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", { class: "text-no-wrap" }, "views", -1)
const _hoisted_9 = { class: "headline text-left pb-1" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = { style: {"padding-top":"14%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "pa-1",
    to: `/tournaments/${_ctx.tournament.id}`,
    variant: "tonal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, { fluid: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            row: "",
            wrap: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4",
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("h1", null, [
                              _createVNode(_component_v_avatar, { size: "40" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_img, {
                                    src: _ctx.tournament.champion.player.avatar
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              })
                            ]),
                            _hoisted_2
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.tournament.champion.votes), 1),
                            _hoisted_5
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.tournament.views), 1),
                            _hoisted_8
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4",
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.tournament.name.toUpperCase()), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_v_chip, { color: "info" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.tournament.tournamentType), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "hidden-sm-and-down"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", null, "ended in " + _toDisplayString(_ctx.endDate), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["to"]))
}